<wlm-dynamic-layout
  *ngIf="layoutSettings"
  [containerClass]="containerClass"
  [settings]="layoutSettings"
></wlm-dynamic-layout>
<wlm-placeholder-overlay
  *ngIf="!layoutSettings"
  [titleKey]="noAttrsTitleKey"
  [subtitleKey]="noAttrsSubtitleKey"
></wlm-placeholder-overlay>
